import { usePraxisCall } from "../praxis-play/context/praxiscall-context";
import { ReportView } from "./components/ReportView";
import type { ReportSummaryItem } from "../../types/report";

export type Conversation = {
  id: string;
  message: string;
  content?: string;
  isUserMessage: boolean;
  session_url?: string | null;
  audio_file?: any;
};

type Report = {
  conversations: Conversation[];
  languageClarity: number;
  vocabulary: number;
  brandStrategy: number;
  questionTechniques: number;
  compliancePercentage: number;
  tone: number;
  duration?: number;
  report: {
    variable_metrics: {
      [key: string]: {
        value: number;
        feedback: string;
      };
    };
    constant_metrics: {
      [key: string]: {
        value: number;
        feedback: string;
      };
    };
    reportScore?: number;
    summary?: string | ReportSummaryItem[];
    coaching_matrix?: any;
  };
  session: {
    sessionID: string;
    userId: string;
  };
};

export function ReportsView() {
  const { setCallStatus, report, detailedReport, detailedReportFetching } = usePraxisCall() as {
    setCallStatus: React.Dispatch<React.SetStateAction<string>>;
    report: Report;
    detailedReport: any;
    detailedReportFetching: boolean;  
  };
  return <ReportView isFromRoleplay={true} report={report} setCallStatus={setCallStatus} detailedReport={detailedReport} detailedReportFetching={detailedReportFetching} />;
}
